function convert12To24(hours, ampm)
{
	return ('PM' == ampm)?12 + hours:hours;
}

export default function editSchedule()
{
	let form = $('.form--reschedule-share'),
		hidHour = $('[name="scheduled_for_hour"]'),
		ddlHour = $('.schedule-time-select--hour'),
		ddlAmPm = $('.schedule-time-select--ampm'),
		changeDropdowns = function() {
			hidHour.val(convert12To24(Number(ddlHour.val()), ddlAmPm.val()));
		};

	hidHour.val(convert12To24(Number(ddlHour.val()), ddlAmPm.val()));

	ddlHour.on('change', changeDropdowns);
	ddlAmPm.on('change', changeDropdowns);
}
